import { Directive, Input, OnChanges, Self, SimpleChanges } from '@angular/core';
import { NgControl, ValidatorFn } from '@angular/forms';
import { toUniversalDateString } from '@assetaccountant/core';

/**
 * Based off: https://github.com/angular/angular/blob/master/packages/forms/src/directives/validators.ts
 */

@Directive({
  selector:
    // eslint-disable-next-line @angular-eslint/directive-selector
    '[minDate][formControlName],[minDate][formControl],[minDate][ngModel]:not([ngbDatepicker])',
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class MinDateValidator implements OnChanges {
  private _validator: ValidatorFn | null = null;
  private _onChange?: () => void;

  @Input() minDate: string | null | undefined;

  constructor(@Self() private control: NgControl) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('minDate' in changes) {
      if (this._validator) {
        this.control.control?.removeValidators(this._validator);
      }
      this._createValidator();
      if (this._validator) {
        this.control.control?.addValidators(this._validator);
      }
      this.control.control?.updateValueAndValidity();
      if (this._onChange) {
        this._onChange();
      }
    }
  }

  private _createValidator(): void {
    const minDate = toUniversalDateString(this.minDate);
    if (minDate) {
      this._validator = control => {
        if (!control) {
          return null;
        }
        const controlValue = toUniversalDateString(control.value);
        if (!controlValue) {
          return null;
        }
        return controlValue >= minDate
          ? null
          : {
              minDate: {
                minDate,
                actualDate: control.value,
              },
            };
      };
    } else {
      this._validator = null;
    }
  }
}
